import type { UnremindMeRequest } from "./types"

import { handleResponseNotOk } from "@/modules/apiRequests/handlers"
import { EVENT_DETAILS_PATH, UNREMIND_ME_ENDPOINT } from "@/modules/eventDetails/client/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

export const getUnremindMe = async (params: UnremindMeRequest): Promise<void> => {
  const { locale, hostname, id } = params

  return fetcher(`/${locale}${EVENT_DETAILS_PATH}${id}${UNREMIND_ME_ENDPOINT}`, {
    hostname,
    serviceDomain: "MONOLITH_API",
  })
    .then(handleResponseNotOk)
    .catch(handleFetchError(UNREMIND_ME_ENDPOINT, params))
}
